import { Component } from '@angular/core';
import { combineLatest, distinctUntilChanged, map, Subscription } from 'rxjs';
import { CustomFieldService } from '../../../services/custom-field.service';
import { Sort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { CustomFieldDefinition } from '../../../models/custom-field.model';
import { PageEvent } from '@angular/material/paginator';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { DEFAULT_SNACKBAR_CONFIG } from 'src/app/@shared/constants/site.constants';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormControl } from '@angular/forms';
import { ConfirmDialogComponent } from 'src/app/@shared';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-custom-fields-list-table',
  templateUrl: './custom-fields-list-table.component.html',
  styleUrls: ['./custom-fields-list-table.component.scss'],
})
export class CustomFieldsListTableComponent {
  viewModel$ = combineLatest([
    this.customFieldService.customFields$,
    this.customFieldService.page$,
    this.customFieldService.totalRecords$,
  ]).pipe(
    map(([fields, page, totalRecords]) => {
      this.customFields = fields;
      return { fields, page, totalRecords };
    }),
  );
  customFields: CustomFieldDefinition[] = [];
  selection = new SelectionModel<any>(true, []);
  displayedColumns = [
    'select',
    'FieldName',
    'DisplayLabel',
    'VertexType',
    'FieldType',
    'DisplayOrder',
    'Actions',
  ];
  flexMediaWatcher!: Subscription;
  searchControl = new FormControl('');

  constructor(
    private customFieldService: CustomFieldService,
    private matSnackBar: MatSnackBar,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {}

  onSearch(event: Event): void {
    this.customFieldService.search((event.target as HTMLInputElement).value);
  }

  clearSearch(): void {
    this.searchControl.setValue('');
    this.customFieldService.search('');
    this.selection.clear();
  }

  onSort(sortState: Sort): void {
    this.customFieldService.sort(sortState);
    this.selection.clear();
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.customFields.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.customFields.forEach((row) => this.selection.select(row));
  }

  public getSelectedSectionRecords() {
    return this.selection.selected || [];
  }

  public clearSelection() {
    this.selection.clear();
  }

  onPage(pageEvent: PageEvent): void {
    this.selection.clear();
    this.customFieldService.page(pageEvent);
  }

  deleteSelectedRecords(): void {
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Confirm Delete',
        message: `Do you want to remove Custom Field(s)?`,
      },
      disableClose: true,
    });
    confirmDialog.afterClosed().subscribe((result) => {
      if(result === true) {
        const selectedIds = this.getSelectedSectionRecords().map(
          (record) => record.Id,
        );
        this.customFieldService.deleteCustomFields(selectedIds).subscribe(() => {
          this.clearSelection();
          this.customFieldService.reload();
          this.matSnackBar.open(
            `Custom Field(s) deleted`,
            'OK',
            DEFAULT_SNACKBAR_CONFIG,
          );
        });
      }
    });
  }
}
